import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './session.reducer';
import { ISession } from 'app/shared/model/session.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ISessionDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export class SessionDetail extends React.Component<ISessionDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { sessionEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="rtnApp.session.detail.title">Session</Translate> [<b>{sessionEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="startTime">
                <Translate contentKey="rtnApp.session.startTime">Start Time</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={sessionEntity.startTime} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="enabled">
                <Translate contentKey="rtnApp.session.enabled">Enabled</Translate>
              </span>
            </dt>
            <dd>{sessionEntity.enabled ? 'true' : 'false'}</dd>
            <dt>
              <Translate contentKey="rtnApp.session.event">Event</Translate>
            </dt>
            <dd>{sessionEntity.event ? sessionEntity.event.id : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/session" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>&nbsp;
          <Button tag={Link} to={`/entity/session/${sessionEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ session }: IRootState) => ({
  sessionEntity: session.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SessionDetail);
